import React from "react";
import { Card, Button, Text, Divider, Flex, Box } from "@mantine/core";
import { useStyles } from "./style";
import { useSelector } from "react-redux";

const PricingCards = (props) => {
  const { classes } = useStyles();
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  console.log("🚀 ~ PricingCards ~ profile:", profile)
  const isTrialUsed = profile?.user && profile?.user?.isTrialUsed === false;

  const {
    item,
    src,
    onClick,
    disabled,
    // isPriceCard,
    // isTrial,
    bothNormal,
    ...properties
  } = props;
  let {
    patient,
    name,
    cost,
    staff,
    notes,
    reports,
    duration,
    facility,
    id: packageId,
    additionalStaff,
    additionalClient,
    additionalFacility,
    promotion,
  } = item;

  const facilityString =
    Number(facility) > 1
      ? `Up to ${facility} facilities`
      : `${facility} Facility`;

  function calculateDiscountedPrice(cost) {
    const discountedPrice =
      duration === "year" ? Number(cost) / 12 : Number(cost) * 0.9;
    return Number(discountedPrice).toFixed(2);
  }

  // console.log( "condition variables" ,{profile, duration, isTrial: profile?.user?.isTrialUsed} )

  return (
    <Card shadow="sm" withBorder className={classes.Card}>
      <Text className={classes.cardStatus}> {name}</Text>
      <div className={classes.cardContent}>
        <Text className={classes.cardAmount}>
          <h2 className={classes.cast}>
            {cost === "0.00" ? "Free" : `$${cost}`}
          </h2>
          {cost === "0.00" ? <p></p> : <p> /{duration}</p>}
        </Text>
        <Flex align="center" className={classes.savePerRow}>
          <p>${calculateDiscountedPrice(cost)} {duration === 'month' ? 'Annualized' : 'Monthly'}</p>
          <Box>Save {promotion}%</Box>
        </Flex>
        <Divider size="sm" mt={20} color="#171717" />
        <ul className={classes.cardList}>
          <li>
            {facilityString}{" "}
            {/* {name === "Free" ? (
              ""
            ) : (
              <span
                style={{
                  fontSize: "13px",
                  color: "#666666",
                  fontWeight: 600,
                }}
              >
                (Additional Facility +${additionalFacility || "20"})
              </span>
            )} */}
          </li>
          <li>
            {staff} staff members{" "}
            {name === "Free" ? (
              ""
            ) : (
              <span
                style={{
                  fontSize: "13px",
                  color: "#666666",
                  fontWeight: 600,
                }}
              >
                (Additional Staff +${additionalStaff || "20"})
              </span>
            )}
          </li>
          <li>
            {patient} Clients{" "}
            {name === "Free" ? (
              ""
            ) : (
              <span
                style={{
                  fontSize: "13px",
                  color: "#666666",
                  fontWeight: 600,
                }}
              >
                (Additional Client +${additionalClient || "15"})
              </span>
            )}
          </li>
          <li>Medication Management/eMAR</li>
          <li>Care Plans</li>
          <li>Client Intake</li>
          {(name === "Starter" || name === "Starter - Yearly") && (
            <>
              <li>Task Management</li>
              <li>Custom Roles</li>
              <li>Document Management </li>
              <li>Staff Management</li>
              <li>Text to Speech</li>
              <li>{notes} Notes</li>
              <li>{reports} Reports</li>
              <li>Clock In/Clock Out</li>
              <li>Invoice</li>
              <li>SkAI (100 queries)</li>
              <li>EVV (Paid - coming soon)</li>
            </>
          )}
          {name === "Bronze" && (
            <>
              <li>Task Management</li>
              <li>Custom Roles</li>
              <li>Document Management </li>
              <li>Staff Management</li>
              <li>Text to Speech</li>
              <li>{notes} Notes</li>
              <li>{reports} Reports</li>
              <li>Clock In/Clock Out</li>
              <li>Invoice</li>
              <li>SkAI (100 queries)</li>
              <li>EVV (Paid - coming soon)</li>
            </>
          )}
          {name === "Silver" && (
            <>
              <li>Custom Roles</li>
              <li>Document Management </li>
              <li>Staff Management</li>
              <li>Task Management</li>
              <li>Text to Speech</li>
              <li>{notes} Notes</li>
              <li>{reports} Reports</li>
              <li>Clock In/Clock Out</li>
              <li>Invoice</li>
              <li>Billing</li>
              <li>SkAI (300 queries)</li>
              <li>EVV (coming soon)</li>
              <li>Scheduler (coming soon)</li>
            </>
          )}
          {name === "Gold" && (
            <>
              <li>Custom Roles</li>
              <li>Document Management </li>
              <li>Staff Management</li>
              <li>Task Management</li>
              <li>Text to Speech</li>
              <li>{notes} Notes</li>
              <li>{reports} Reports</li>
              <li>Clock In/Clock Out</li>
              <li>Invoice</li>
              <li>Billing</li>
              <li>SkAI (Unlimited queries)</li>
              <li>EVV (coming soon)</li>
              <li>Scheduler (coming soon)</li>
            </>
          )}
          {name === "Free" && (
            <>
              <li>Custom Roles (coming soon)</li>
              <li> Staff Management (coming soon)</li>
              <li>{notes} Notes</li>
              <li>{reports} Reports</li>
            </>
          )}
        </ul>
      </div>
      {/* {(!profile || !isTrialUsed) && duration !== "year" && (
        <p className={classes.trialUsedText}>14 days free trial</p>
      )} */}
      {(!profile || (!profile?.user?.isTrialUsed && duration !== "year")) && (
        <p className={classes.trialUsedText}>14 days free trial</p>
        )}
      {/* {
        !profile ?
         <p className={classes.trialUsedText}>14 days free trial</p> : 
         profile ? (!isTrialUsed && duration !== "year") ? 
         <p className={classes.trialUsedText}>14 days free trial</p> : "" : "" 
      } */}
      <Button
        className={classes.cardButton}
        disabled={disabled}
        onClick={() => onClick(packageId)}
      >
        {/* {"Select Plan"} */}
        {duration === "year"
          ? "Coming Soon"
          // : !isTrialUsed
          : !profile?.user?.isTrialUsed
          ? "Try for free"
          : "Get Started"}
      </Button>
    </Card>
  );
};

export default PricingCards;

// const PricingCards = (props) => {
//   const { classes } = useStyles();
//   const {
//     item,
//     src,
//     onClick,
//     disabled,
//     // isPriceCard,
//     // isTrial,
//     bothNormal,
//     ...properties
//   } = props;
//   let {
//     patient,
//     name,
//     cost,
//     staff,
//     notes,
//     reports,
//     duration,
//     facility,
//     id: packageId,
//     additionalStaff,
//     additionalClient,
//     additionalFacility,
//   } = item;

//   const facilityString =
//     Number(facility) > 1
//       ? `Up to ${facility} facilities`
//       : `${facility} Facility`;

//   const packageColor =
//     name === "Starter"
//       ? "#000000" :
//     name === "Bronze"
//       ? "#cd7f32"
//       : name === "Silver"
//       ? "#e4e4e4"
//       : name === "Gold"
//       ? "#ffb435"
//       : "#000000";

//   return (
//     <div className={classes.cardContainer}>
//       <Card shadow="sm" withBorder className={classes.Card}>
//         <Text className={classes.cardStatus}> {name}</Text>
//         <div
//           className={classes.cardColor}
//           style={{ background: packageColor }}
//         ></div>
//         <div className={classes.cardContent}>
//           <Text className={classes.cardAmount}>
//             <h2 className={classes.cast}>
//               {cost === "0.00" ? "Free" : `$${cost}`}
//             </h2>
//             {cost === "0.00" ? <p></p> : <p> /{duration}</p>}
//           </Text>
//           <ul className={classes.cardList}>
//             <li>
//               {facilityString}{" "}
//               {name === "Free" ? (
//                 ""
//               ) : (
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#666666",
//                     fontWeight: 600,
//                   }}
//                 >
//                   (Additional Facility +${additionalFacility})
//                 </span>
//               )}
//             </li>
//             <li>
//               {staff} staff members{" "}
//               {name === "Free" ? (
//                 ""
//               ) : (
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#666666",
//                     fontWeight: 600,
//                   }}
//                 >
//                   (Additional Staff +${additionalStaff})
//                 </span>
//               )}
//             </li>
//             <li>
//               {patient} Clients{" "}
//               {name === "Free" ? (
//                 ""
//               ) : (
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#666666",
//                     fontWeight: 600,
//                   }}
//                 >
//                   (Additional Client +${additionalClient})
//                 </span>
//               )}
//             </li>
//             <li>Medication Management/eMAR</li>
//             <li>Care Plans</li>
//             <li>Client Intake</li>
//             {name === "Starter" && (
//               <>
//                 <li>Task Management</li>
//                 <li>Custom Roles</li>
//                 <li>Document Management </li>
//                 <li>Staff Management</li>
//                 <li>Text to Speech</li>
//                 <li>{notes} Notes</li>
//                 <li>{reports} Reports</li>
//                 <li>Clock In/Clock Out</li>
//                 <li>Invoice</li>
//                 <li>SkAI (100 queries)</li>
//                 <li>EVV (Paid - coming soon)</li>
//               </>
//             )}
//             {name === "Bronze" && (
//               <>
//                 <li>Task Management</li>
//                 <li>Custom Roles</li>
//                 <li>Document Management </li>
//                 <li>Staff Management</li>
//                 <li>Text to Speech</li>
//                 <li>{notes} Notes</li>
//                 <li>{reports} Reports</li>
//                 <li>Clock In/Clock Out</li>
//                 <li>Invoice</li>
//                 <li>SkAI (100 queries)</li>
//                 <li>EVV (Paid - coming soon)</li>
//               </>
//             )}
//             {name === "Silver" && (
//               <>
//                 <li>Custom Roles</li>
//                 <li>Document Management </li>
//                 <li>Staff Management</li>
//                 <li>Text to Speech</li>
//                 <li>{notes} Notes</li>
//                 <li>{reports} Reports</li>
//                 <li>Clock In/Clock Out</li>
//                 <li>Invoice</li>
//                 <li>Billing</li>
//                 <li>SkAI (300 queries)</li>
//                 <li>EVV (coming soon)</li>
//                 <li>Scheduler (coming soon)</li>
//               </>
//             )}
//             {name === "Gold" && (
//               <>
//                 <li>Custom Roles</li>
//                 <li>Document Management </li>
//                 <li>Staff Management</li>
//                 <li>Task Management</li>
//                 <li>Text to Speech</li>
//                 <li>{notes} Notes</li>
//                 <li>{reports} Reports</li>
//                 <li>Clock In/Clock Out</li>
//                 <li>Invoice</li>
//                 <li>Billing</li>
//                 <li>SkAI (Unlimited queries)</li>
//                 <li>EVV (coming soon)</li>
//                 <li>Scheduler (coming soon)</li>
//               </>
//             )}
//             {name === "Free" && (
//               <>
//                 <li>Custom Roles (coming soon)</li>
//                 <li> Staff Management (coming soon)</li>
//                 <li>{notes} Notes</li>
//                 <li>{reports} Reports</li>
//               </>
//             )}
//           </ul>
//         </div>
//         <div
//           className={classes.btnContainer}
//           style={{ position: "absolute", bottom: "0px" }}
//         >
//           <Button
//             className={classes.cardButton}
//             disabled={disabled}
//             onClick={() => onClick(packageId)}
//           >
//             {/* {"Select Plan"} */}
//             Try Trial
//           </Button>
//         </div>
//       </Card>
//     </div>
//   );
// };

// export default PricingCards;
// import React from "react";
// import { Card, Button, Text } from "@mantine/core";
// import { useStyles } from "./style";
// const PricingCards = (props) => {
//   const { classes } = useStyles();
//   const {
//     item,
//     src,
//     onClick,
//     disabled,
//     isPriceCard,
//     isTrial,
//     bothNormal,
//     ...properties
//   } = props;
//   let {
//     patient,
//     name,
//     cost,
//     staff,
//     notes,
//     reports,
//     duration,
//     facility,
//     id: packageId,
//     additionalStaff,
//     additionalClient,
//     additionalFacility,
//   } = item;

//   const facilityString =
//     Number(facility) > 1
//       ? `Up to ${facility} facilities`
//       : `${facility} Facility`;

//   const packageColor =
//     name === "Trial"
//       ? "#000000"
//       : name === "Silver"
//       ? "#e4e4e4"
//       : name === "Gold"
//       ? "#ffb435"
//       : "#000000";

//   return (
//     <div className={classes.cardContainer}>
//       <Card shadow="sm" withBorder className={classes.Card}>
//         <Text className={classes.cardStatus}> {name}</Text>
//         <div
//           className={classes.cardColor}
//           style={{ background: packageColor }}
//         ></div>
//         <div className={classes.cardContent}>
//           <Text className={classes.cardAmount}>
//             <h2 className={classes.cast}>
//               {cost === "0.00" ? "Free" : `$${cost}`}
//             </h2>
//             {cost === "0.00" ? <p></p> : <p> /{duration}</p>}
//           </Text>
//           <ul className={classes.cardList}>
//             <li>
//               {facilityString}{" "}
//               {name === "Free" ? (
//                 ""
//               ) : (
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#666666",
//                     fontWeight: 600,
//                   }}
//                 >
//                   (Additional Facility +${additionalFacility})
//                 </span>
//               )}
//             </li>
//             <li>
//               {staff} staff members{" "}
//               {name === "Free" ? (
//                 ""
//               ) : (
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#666666",
//                     fontWeight: 600,
//                   }}
//                 >
//                   (Additional Staff +${additionalStaff})
//                 </span>
//               )}
//             </li>
//             <li>
//               {patient} Resident/Clients{" "}
//               {name === "Free" ? (
//                 ""
//               ) : (
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#666666",
//                     fontWeight: 600,
//                   }}
//                 >
//                   (Additional Client +${additionalClient})
//                 </span>
//               )}
//             </li>
//             <li>Medication Management/eMAR</li>
//             <li>Care Plans</li>
//             <li>Client Intake</li>
//             {name === "Silver" && (
//               <>
//                 <li>Custom Roles (coming soon)</li>
//                 <li>Document Management </li>
//                 <li>Staff Management (coming soon)</li>
//                 <li>Text to Speech</li>
//                 <li>{notes} Notes</li>
//                 <li>{reports} Reports</li>
//               </>
//             )}
//             {name === "Gold" && (
//               <>
//                 <li>Custom Roles (coming soon)</li>
//                 <li>Document Management </li>
//                 <li>Staff Management (coming soon)</li>
//                 <li>Task Management</li>
//                 <li>Text to Speech</li>
//                 <li>{notes} Notes</li>
//                 <li>{reports} Reports</li>
//                 <li>Forms (coming soon)</li>
//                 <li>Scheduler (coming soon)</li>
//                 <li>Sky Al (coming soon)</li>
//               </>
//             )}
//             {name === "Free" && (
//               <>
//                 <li>Custom Roles (coming soon)</li>
//                 <li> Staff Management (coming soon)</li>
//                 <li>{notes} Notes</li>
//                 <li>{reports} Reports</li>
//               </>
//             )}
//           </ul>
//         </div>
//         <div
//           className={classes.btnContainer}
//           style={{ position: "absolute", bottom: "0px" }}
//         >
//           <Button
//             className={classes.cardButton}
//             disabled={disabled}
//             onClick={() => onClick(packageId)}
//           >
//             {"Select Plan"}
//           </Button>
//         </div>
//       </Card>
//     </div>
//   );
// };

// export default PricingCards;
